import { CaseBanner } from '../CaseBanner';
import { ColorPicker } from '../ColorPicker';
import { VehicleSpecs } from '../VehicleSpecs';
import { StyledMenuContainer } from './VehicleStats.styled';

const VehicleStats = (props: React.HtmlHTMLAttributes<HTMLDivElement>) => (
	<StyledMenuContainer {...props}>
		<CaseBanner />
		<VehicleSpecs />
		<ColorPicker />
	</StyledMenuContainer>
);
export { VehicleStats };
